import React from "react";
import { PnrMock1 } from "./PNR/Pnr.Mocks";

export const Playground: React.FC<{}> = ({ }) => {
    return <div className="container xl-wrapper content-wrapper">
        <PnrMock1></PnrMock1>
        {/* {SmartBookResponseDataModelMock1} */}
    </div>
}